import React from 'react';
import { Box } from '@mui/material';
import LotServicioDeficitRow from './LotServicioDeficitRow';
import { SERVICE_DEFICIT_INDICATORS } from '../../../utils/serviceDeficitDisplay';

/**
 * Tres filas de servicios básicos del radio censal (Censo 2022).
 */
const LotServiciosBasicosSection = ({
  waterNetworkDeficitPct = null,
  sewerDeficitPct = null,
  cookingFuelDeficitPct = null,
}) => {
  const valuesByKey = {
    water_network_deficit_pct: waterNetworkDeficitPct,
    sewer_deficit_pct: sewerDeficitPct,
    cooking_fuel_deficit_pct: cookingFuelDeficitPct,
  };

  return (
    <>
      {SERVICE_DEFICIT_INDICATORS.map((indicator, index) => (
        <Box
          key={indicator.key}
          sx={index < SERVICE_DEFICIT_INDICATORS.length - 1
            ? { borderBottom: '1px solid rgba(255,255,255,0.08)' }
            : undefined}
        >
          <LotServicioDeficitRow
            indicator={indicator}
            value={valuesByKey[indicator.key]}
          />
        </Box>
      ))}
    </>
  );
};

export default LotServiciosBasicosSection;
